import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import { Input } from '../../../components/ModalInputs'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../../../components/Table'
import Confirmation from '../../../components/Confirmation/Confirmation'
import Modal from 'react-responsive-modal'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import Button from '../../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { createAdmissionDisciplines } from '../../../actions/admissions'
import { BiTrash } from 'react-icons/bi'
import { removeUnnecessaryKey } from '../../../utils/smallHelpers'
import CustomSelect from '../../../components/CustomSelect'
import { createNotification } from '../../../components/Notifications/Notifications'

const PARALLELS = [
    { value: 1, name: '1' },
    { value: 2, name: '2' },
    { value: 3, name: '3' },
    { value: 4, name: '4' },
    { value: 5, name: '5' },
    { value: 6, name: '6' },
    { value: 7, name: '7' },
    { value: 8, name: '8' },
    { value: 9, name: '9' },
    { value: 10, name: '10' },
    { value: 11, name: '11' },
]


const Index = ({ values, handleChange, setFieldValue, addMode }) => {

    const dispatch = useDispatch()


    const { admissionDisciplines, } = useSelector(state => state.admissions) // содержание как в exams нет сортировки
    const { lessons, } = useSelector(state => state.classbook)

    const [openList, setOpenList] = useState(false)
    const [confirmation, setConfirmation] = useState(false);
    const [openPersonal, setOpenPersonal] = useState(false);
    const [selected, setSelected] = useState({});

    const keysToDelete = ['id', 'name']

    useEffect(() => {
        values && setSelected({
            "school_year": values.school_year,
            "kurs": '',
            "stream": values.stream,
            "lid": '',
            "question_count": '',
            "sorting": values.exams.length + 1,
            'id_enroll_comitet': values.id,
        })
    }, [values])

    const uniqueDisciplinesKurs = values && Array.from(new Set(values.exams.map(item => item.kurs)))
        .map(kurs => values.exams.find(item => (item.kurs === kurs)).kurs).sort();


    const acceptConfirmation = () => {
        // dispatch(deleteAdmissionComitet({ mid: confirmation.id, id: data.id }));
        setConfirmation(false);
    };

    const rejectConfirmation = () => {
        setConfirmation(false);
    };

    const openModalPersonal = () => {
        setOpenPersonal(true)
    }
    const openClassList = (kurs) => {
        // setSelectedClass(kurs)
        setOpenList(kurs)
    }
    const closeModalPersonal = () => {
        setOpenPersonal(false)
    }

    const handleSubmitPersonal = () => {
        // dispatch(createAdmissionDisciplines(removeUnnecessaryKey({ ...selected }, ...keysToDelete)))
        if (selected.kurs && selected.question_count) {
            dispatch(createAdmissionDisciplines(selected));
            closeModalPersonal();
            setSelected({
                school_year: values.school_year,
                kurs: '',
                stream: values.stream,
                lid: '',
                question_count: '',
                sorting: values.exams.length + 1,
                id_enroll_comitet: values.id,
            });
        } else {
            createNotification('error', 'Выберите класс и Кол-во вопросов');
        }
    }
    const setFieldValue2 = (name, value) => {
        setSelected(prev => ({ ...prev, [name]: +value }))
    }

    return (
        <>
            <div className={styles.modalLocal} >
                {confirmation && (
                    <Confirmation
                        top="30px"
                        left="40px"
                        title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
                        acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
                        rejectConfirmation={rejectConfirmation}
                    />
                )}
                <div className={styles.tabWrapperModal} >

                    {/* МОДАЛКА С ВЫБОРОМ  НОВОЙ ДИСЦ  */}
                    {openPersonal &&
                        < Modal
                            open={openPersonal}
                            onClose={() => false}
                            showCloseIcon={false}
                            classNames={{
                                // overlay: styles.overlay,
                                modal: styles.custom
                            }}
                            center
                        >
                            <div className={styles.modalLocal} >
                                <div className={styles.tabWrapperSubModal} >
                                    <Table >
                                        <thead>
                                            <tr>
                                                <th>Дисциплина</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lessons && lessons.map(el =>
                                                <>
                                                    <tr key={el.lid} className={selected.lid == el.lid ? styles.person : ''}>
                                                        <td onClick={() => setFieldValue2("lid", el.lid)} style={{ width: '550px' }} >{el.name}</td>
                                                        {/* <td><i className={styles.trash} onClick={() => setConfirmation({ id: el.lid, name: el.name })}><BiTrash /></i></td> */}
                                                    </tr>
                                                    {el.lid === selected.lid &&
                                                        <div className={styles.selKursRow}>
                                                            {/* <div className={styles.inputsRow}> */}
                                                            <CustomSelect
                                                                title='Класс'
                                                                valuesName="kurs"
                                                                options={PARALLELS}
                                                                width='100px'
                                                                setFieldValue={setFieldValue2}
                                                                value={selected.kurs}
                                                                className={styles.selectKurs}
                                                            // value={streams.find(el => el.value == stream)?.name}
                                                            // disabled={data.type === 1 ? false : true}
                                                            />
                                                            <Input
                                                                name='question_count'
                                                                label='Кол-во вопросов'
                                                                value={selected.question_count}
                                                                onChange={e => setFieldValue2('question_count', e.target.value)}
                                                                className={styles.labelKurs}
                                                            // inputName={styles.inputKurs}
                                                            // onBlur={handleBlur}
                                                            // error={error('name')}
                                                            />
                                                        </div>
                                                    }

                                                </>
                                            )}
                                        </tbody>
                                    </Table>

                                </div>
                            </div>
                            <ModalFooter handleSubmit={handleSubmitPersonal} closeModal={closeModalPersonal} />
                        </Modal>
                    }
                    {/* МОДАЛКА С ВЫБОРОМ НОВОЙ ДИСЦ */}

                    <Table className={styles.tablePersonal}>
                        <thead>
                            <tr>
                                <th style={{ width: '550px' }}>Дисциплина</th>
                                <th style={{ width: '250px' }}>Кол-во вопросов</th>
                            </tr>
                        </thead>
                        <tbody >
                            {admissionDisciplines && uniqueDisciplinesKurs.map(kurs =>
                                <>
                                    <tr className={styles.class} onClick={() => openClassList(kurs)} >
                                        <th colspan='2'>
                                            {kurs} класс
                                        </th>
                                    </tr>

                                    {openList == kurs && values && values.exams.map(el =>
                                        el.kurs === kurs &&
                                        <>
                                            <tr key={el.sorting} >
                                                <td onClick={() => { }} style={{ width: '550px' }} >{el.exam_name}</td>
                                                <td onClick={() => { }} style={{ width: '250px' }} >{el.question_count}</td>
                                            </tr>
                                        </>

                                    )}
                                </>

                            )}

                        </tbody>
                        {/* <td><i className={styles.trash} onClick={() => setConfirmation({ id: el.mid, name: el.fio })}><BiTrash /></i></td> */}
                    </Table>
                    <div className={styles.inputsRow}>
                        <Button
                            style={{ padding: '.5rem 1.5rem', margin: '12px' }}
                            onClick={openModalPersonal}
                        >
                            <IoIosAdd size={30} />
                            Добавить
                        </Button>

                    </div>

                </div>
            </div>

        </>
    )
}

export default Index